import React, { useState, useEffect } from "react";
import * as Yup from "yup";
import { Modal, Alert, Table } from "react-bootstrap";
import { Field, Form, Formik } from "formik";
import { baseUrl } from "../../../services/config";
import { Link } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import jwt_token from "../../../services/authToken";
import { useAlert } from "react-alert";
import { useSelector } from "react-redux";
import MySelect from "./../CustomChallan/MySelect";
import makeAnimated from "react-select/animated";
import { components } from "react-select";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import AddIcon from "@material-ui/icons/Add";

const AddUserCampuses = ({ show, onHide, reload, subjectsData = [] }) => {
  const alert = useAlert();
  const authToken = jwt_token();
  const user = useSelector((state) => state.user.user);

  const [loading, setLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [errorsLis, setErrorsLis] = useState("");
  let [errorcreate, seterrorcreate] = useState("Please fill all fields");
  let [isallfields, setisallfields] = useState(false);
  const [addloading, setaddloading] = useState(false);

  const [usersData, setUsersData] = useState([]);
  const [usersArray, setUsersArray] = useState([]);
  const [campusesList, setCampusesList] = useState([]);
  const [classesList, setClassesList] = useState([]);
  const [sectionsList, setSectionsList] = useState([]);

  const [selectedUser, setSelectedUser] = useState("");
  const [campusIds, setCampusIds] = useState([]);
  const [classIds, setClassIds] = useState([]);
  const [selectedCampuses, setSelectedCampuses] = useState([]);
  const [selectedClasses, setSelectedClasses] = useState([]);
  const [selectedSections, setSelectedSections] = useState([]);
  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [createArray, setCreateArray] = useState([]);

  useEffect(() => {
    GetAllUsers();
    // getAllCampus();
  }, []);

  const GetAllUsers = async () => {
    await fetch(`${baseUrl}/users`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setUsersData(data.payload);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // const getAllCampus = async () => {
  //   await fetch(`${baseUrl}/campus`, {
  //     method: "GET",
  //     headers: {
  //       Authorization: `Bearer ${authToken}`,
  //     },
  //   })
  //     .then((res) => res.json())
  //     .then((data) => {
  //       let arr = [];

  //       data.payload.forEach((element) => {
  //         arr.push({
  //           label: element.name,
  //           value: element.id,
  //         });
  //       });
  //       setCampusesList(arr);
  //     })
  //     .catch((err) => {
  //       console.log("campus", err);
  //     });
  // };

  const getUserCampusesClasses = (campusIds) => {
    if (!campusIds || campusIds.length === 0) {
      return alert.error("Please select at least one campus");
    }

    let data = {
      campus_ids: campusIds,
    };

    fetch(`${baseUrl}/campuses-classes`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },

      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        let arr = [];

        data.payload.forEach((element) => {
          arr.push({
            label:
              element?.student_class?.name + " (" + element?.campus?.name + ")",
            student_class_id: element?.student_class_id,
            campus_id: element?.campus_id,
            value: element.id,
          });
        });
        setClassesList(arr);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getClassSections = (classIds) => {
    if (campusIds.length == 0 || classIds.length == 0) {
      return alert.error("Please select at least one campus or class");
    }

    let data = {
      campus_ids: campusIds,
      student_class_ids: classIds,
    };

    fetch(`${baseUrl}/campuses-classes-sections`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },

      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        let arr = [];

        data.payload.forEach((element) => {
          arr.push({
            label:
              element?.section?.name +
              " (" +
              element?.class?.name +
              " - " +
              element?.campus?.name +
              " )",
            student_class_id: element?.student_class_id,
            global_section_id: element?.global_section_id,
            campus_id: element?.campus_id || element?.campus?.id,
            value: element.id,
          });
        });
        setSectionsList((current) => {
          const optionKey = (item) =>
            `${item.campus_id}-${item.student_class_id}-${item.global_section_id}`;
          const options = [...current, ...arr];
          return options.filter(
            (item, index) =>
              options.findIndex(
                (option) => optionKey(option) === optionKey(item),
              ) === index,
          );
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const AddUserCampusesHandle = async () => {
    if (
      campusIds.length == 0 ||
      createArray.length == 0 ||
      usersArray.length == 0 ||
      selectedUser == ""
    ) {
      setisallfields(true);
      setLoading(false);
      return;
    }
    let data = {
      user_id: usersArray[0]?.user_id,
      teacher_classes: createArray,
    };

    setaddloading(true);

    fetch(`${baseUrl}/user-campuses-classes-sections`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },

      body: JSON.stringify(data),
    })
      .then((res) =>
        res.json().then((data) => {
          if (data.metadata.success) {
            disableLoading();
            setisallfields(false);
            setaddloading(false);
            setSelectedUser("");
            setUsersArray([]);
            setCampusIds([]);
            setCampusIds([]);
            setSelectedCampuses([]);
            setSelectedClasses([]);
            setSelectedSections([]);
            setSelectedSubjects([]);
            setCreateArray([]);
            alert.success("User Campus Successfully Added");
            reload(selectedUser);
            onHide(false);
          } else if (data.metadata.message) {
            alert.error(data.metadata.message);
            disableLoading();
            setisallfields(false);
            setaddloading(false);
            seterrorcreate("");
            onHide(false);
          }
        }),
      )
      .catch((err) => {
        disableLoading();
        setisallfields(false);
        setaddloading(false);
        seterrorcreate("");
        alert.error(err);

        onHide(false);
      });
  };

  const enableLoading = () => {
    setLoading(true);
  };

  const disableLoading = () => {
    setLoading(false);
  };

  const animatedComponents = makeAnimated();
  const Option = (props) => {
    return (
      <div>
        <components.Option {...props}>
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
          />{" "}
          <label>{props.label}</label>
        </components.Option>
      </div>
    );
  };

  const MultiValue = (props) => (
    <components.MultiValue {...props}>
      <span>{props.data.label}</span>
    </components.MultiValue>
  );

  const handleUserChange = (value) => {
    const newUser = {
      user_id: value,
      campuses: [],
    };
    console.log(newUser, "newUser at user change");
    // Overwrite the entire array with just the one selected user
    setUsersArray([newUser]);
    setSelectedUser(value);
    setCampusIds([]);
    setClassIds([]);
    setSelectedCampuses([]);
    setSelectedClasses([]);
    setSelectedSections([]);
    setSelectedSubjects([]);
    setCreateArray([]);
  };

  const handleCampusChange = (selected) => {
    const campuses = selected || [];
    setSelectedCampuses(campuses);
    setSelectedClasses([]);
    setSelectedSections([]);
    setSelectedSubjects([]);
    setClassIds([]);
    setCreateArray([]);

    // Extract campus IDs
    const valuearray = campuses.map((item) => item.value);
    console.log(valuearray, "filtered campus array");

    // Update only the selected user's campuses
    const updatedUsersArray = usersArray.map((user) => {
      if (user.user_id === selectedUser) {
        const userCampuses = campuses.map((campus) => ({
          campus_id: campus.value,
          classes: [], // initialize empty
        }));

        return { ...user, campuses: userCampuses };
      }
      return user;
    });

    console.log(updatedUsersArray, "filtered campus array");
    setUsersArray(updatedUsersArray);
    setCampusIds(valuearray);
    setClassesList([]);
    setSectionsList([]);
    if (valuearray.length > 0) getUserCampusesClasses(valuearray);
  };

  const handleClassChange = (campusIds, selectedClasses) => {
    const classes = selectedClasses || [];
    console.log("Selected classes:", selectedClasses);
    console.log("Selected campusIds:", campusIds);

    setSelectedClasses(classes);
    setSelectedSections([]);

    const valuearray = classes.map((item) => item.student_class_id); // Extract class IDs
    setClassIds(valuearray);
    if (valuearray.length > 0) getClassSections(valuearray);

    const campusClassMap = [];
    classes.forEach((cls) => {
      const campusId = cls.campus_id;
      if (!campusClassMap[campusId]) {
        campusClassMap[campusId] = [];
      }
      campusClassMap[campusId].push({
        class_id: cls.student_class_id,
        section_ids: [],
      });
    });

    const updatedUsersArray = usersArray.map((user) => {
      if (user.user_id == selectedUser) {
        const updatedCampuses = user.campuses.map((campus) => {
          if (campusClassMap[campus.campus_id]) {
            return {
              ...campus,
              classes: campusClassMap[campus.campus_id],
            };
          }
          return campus;
        });

        return { ...user, campuses: updatedCampuses };
      }
      return user;
    });

    console.log("Updated users array:", updatedUsersArray);
    setUsersArray(updatedUsersArray);
  };

  const handleSectionChange = (campusIds, classIds, selected) => {
    const sections = selected || [];
    console.log("Selected campusIds:", campusIds);
    console.log("Selected classIds:", classIds);
    console.log("Selected Sections:", selected);

    setSelectedSections(sections);

    // Step 1: Group section_ids by class_id
    const classSectionMap = {};

    sections.forEach((item) => {
      const classId = item.student_class_id;
      const sectionId = item.global_section_id;

      if (!classSectionMap[classId]) {
        classSectionMap[classId] = [];
      }
      classSectionMap[classId].push(sectionId);
    });

    console.log("Grouped class-section map:", classSectionMap);

    // Map and update user object deeply
    const updatedUsersArray = usersArray.map((user) => {
      if (user.user_id === selectedUser) {
        const updatedCampuses = user.campuses.map((campus) => {
          if (campusIds.includes(campus.campus_id)) {
            const updatedClasses = campus.classes.map((cls) => {
              if (classIds.includes(cls.class_id)) {
                return {
                  ...cls,
                  section_ids: classSectionMap[cls.class_id],
                };
              }
              return cls;
            });

            return {
              ...campus,
              classes: updatedClasses,
            };
          }
          return campus;
        });

        return {
          ...user,
          campuses: updatedCampuses,
        };
      }
      return user;
    });

    console.log("Updated users array:", updatedUsersArray);
    setUsersArray(updatedUsersArray);
  };

  const handleAddAssignments = () => {
    if (
      selectedClasses.length === 0 ||
      selectedSections.length === 0 ||
      selectedSubjects.length === 0
    ) {
      seterrorcreate("Please select at least one class, section and subject");
      setisallfields(true);
      return;
    }

    const selectedClassIds = selectedClasses.map((item) =>
      String(item.student_class_id),
    );
    const assignments = [];

    selectedSections.forEach((section) => {
      if (!selectedClassIds.includes(String(section.student_class_id))) return;

      selectedSubjects.forEach((subject) => {
        assignments.push({
          campus_id: section.campus_id,
          student_class_id: section.student_class_id,
          global_section_id: section.global_section_id,
          subject_id: subject.value,
        });
      });
    });

    setCreateArray((current) => {
      const assignmentKey = (item) =>
        `${item.campus_id}-${item.student_class_id}-${item.global_section_id}-${item.subject_id}`;
      const existingKeys = new Set(current.map(assignmentKey));
      const additions = assignments.filter(
        (assignment) => !existingKeys.has(assignmentKey(assignment)),
      );
      return [...current, ...additions];
    });
    setisallfields(false);
    seterrorcreate("Please fill all fields");
  };

  const handleRemoveAssignment = (indexToRemove) => {
    setCreateArray((current) =>
      current.filter((_, index) => index !== indexToRemove),
    );
  };

  const getCampusLabel = (campusId) =>
    campusesList.find((item) => String(item.value) === String(campusId))
      ?.label || campusId;

  const getClassLabel = (campusId, classId) =>
    classesList.find(
      (item) =>
        String(item.campus_id) === String(campusId) &&
        String(item.student_class_id) === String(classId),
    )?.label || classId;

  const getSectionLabel = (campusId, classId, sectionId) =>
    sectionsList.find(
      (item) =>
        String(item.campus_id) === String(campusId) &&
        String(item.student_class_id) === String(classId) &&
        String(item.global_section_id) === String(sectionId),
    )?.label || sectionId;

  const getSubjectLabel = (subjectId) =>
    subjectsData.find((item) => String(item.id) === String(subjectId))?.name ||
    subjectId;

  return (
    <Modal size="lg" show={show} aria-labelledby="example-modal-sizes-title-lg">
      <Modal.Header className="modal_header_style" closeButton>
        <Modal.Title
          className="Modal_Heading_font"
          id="contained-modal-title-vcenter"
        >
          Add User Campuses
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {addloading ? (
          <b style={{ color: "green" }}>
            New User Adding Please Wait {` `}{" "}
            <span className="spinner-border"></span>
          </b>
        ) : (
          <div>
            <div className="form-group row">
              <div className="col-lg-6 mb-4">
                <label className="form-label">
                  <b>Select User</b> <span style={{ color: "red" }}> *</span>
                </label>
                <select
                  className="form-select"
                  name="user_id"
                  style={{ height: 37 }}
                  aria-label="Default select example"
                  value={selectedUser || ""}
                  onChange={(e) => {
                    const selectedId = e.target.value;
                    const selectedObj = usersData.find(
                      (user) => user.id == selectedId,
                    );

                    if (selectedObj) {
                      handleUserChange(selectedId); // pass full object

                      // Extract campuses and set list
                      const campusesTemp = selectedObj.campuses.map((item) => ({
                        value: item.id,
                        label: item.name,
                      }));

                      setCampusesList(campusesTemp);
                    } else {
                      handleUserChange("");
                      setCampusesList([]);
                    }
                  }}
                >
                  <option value="">Select User</option>
                  {usersData &&
                    usersData.map((item, index) => (
                      <option key={index} value={item.id}>
                        {item.first_name + " " + item.last_name}
                      </option>
                    ))}
                </select>
              </div>
              <div className="col-lg-6 mb-4">
                <label>
                  <b>Select Campuses</b>{" "}
                  <span style={{ color: "red" }}> *</span>
                </label>
                <MySelect
                  isMulti
                  value={selectedCampuses}
                  onChange={(newVal) => handleCampusChange(newVal)}
                  options={campusesList}
                  closeMenuOnSelect={true}
                  hideSelectedOptions={false}
                  name="selectedCampuses"
                  components={{
                    Option,
                    MultiValue,
                    animatedComponents,
                  }}
                  allowSelectAll={true}
                />
              </div>
            </div>

            <div className="form-group row">
              <div className="col-lg-6 mb-4">
                <label className="form-label">
                  <b>Select Classes</b> <span style={{ color: "red" }}> *</span>
                </label>
                <MySelect
                  isMulti
                  value={selectedClasses}
                  onChange={(newVal) => handleClassChange(campusIds, newVal)}
                  options={classesList}
                  closeMenuOnSelect={true}
                  hideSelectedOptions={false}
                  name="selectedClasses"
                  components={{
                    Option,
                    MultiValue,
                    animatedComponents,
                  }}
                  allowSelectAll={true}
                />
              </div>
              <div className="col-lg-6 mb-4">
                <label>
                  <b>Select Sections</b>{" "}
                  <span style={{ color: "red" }}> *</span>
                </label>
                <MySelect
                  isMulti
                  value={selectedSections}
                  onChange={(newVal) =>
                    handleSectionChange(campusIds, classIds, newVal)
                  }
                  options={sectionsList}
                  closeMenuOnSelect={true}
                  hideSelectedOptions={false}
                  name="selectedSetions"
                  components={{
                    Option,
                    MultiValue,
                    animatedComponents,
                  }}
                  allowSelectAll={true}
                />
              </div>
            </div>

            <div className="form-group row align-items-end">
              <div className="col-lg-10 mb-4">
                <label>
                  <b>Select Subjects</b>{" "}
                  <span style={{ color: "red" }}> *</span>
                </label>
                <MySelect
                  isMulti
                  value={selectedSubjects}
                  onChange={(newVal) => setSelectedSubjects(newVal || [])}
                  options={subjectsData.map((subject) => ({
                    label: subject.name,
                    value: subject.id,
                  }))}
                  closeMenuOnSelect={true}
                  hideSelectedOptions={false}
                  name="selectedSubjects"
                  components={{
                    Option,
                    MultiValue,
                    animatedComponents,
                  }}
                  allowSelectAll={true}
                />
              </div>
              <div className="col-lg-2 mb-4">
                <button
                  type="button"
                  className="btn btn-primary w-100"
                  onClick={handleAddAssignments}
                >
                  <AddIcon fontSize="small" className="mr-1" />
                  Add
                </button>
              </div>
            </div>

            {createArray.length > 0 && (
              <div className="table-responsive mb-4">
                <Table size="sm">
                  <thead>
                    <tr className="text-center">
                      <th>Campus</th>
                      <th>Class</th>
                      <th>Section</th>
                      <th>Subject</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {createArray.map((assignment, index) => (
                      <tr
                        className="text-center"
                        key={`${assignment.campus_id}-${assignment.student_class_id}-${assignment.global_section_id}-${assignment.subject_id}`}
                      >
                        <td>{getCampusLabel(assignment.campus_id)}</td>
                        <td>
                          {getClassLabel(
                            assignment.campus_id,
                            assignment.student_class_id,
                          )}
                        </td>
                        <td>
                          {getSectionLabel(
                            assignment.campus_id,
                            assignment.student_class_id,
                            assignment.global_section_id,
                          )}
                        </td>
                        <td>{getSubjectLabel(assignment.subject_id)}</td>
                        <td>
                          <span
                            onClick={() => handleRemoveAssignment(index)}
                            style={{ cursor: "pointer" }}
                            className="svg-icon svg-icon-md svg-icon-danger"
                          >
                            <SVG
                              src={toAbsoluteUrl(
                                "/media/svg/icons/General/Trash.svg",
                              )}
                            />
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            )}

            {isallfields ? (
              <>
                <Alert
                  variant="danger"
                  onClose={() => setisallfields(false)}
                  dismissible
                >
                  <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
                  <p>{errorcreate}</p>
                </Alert>
              </>
            ) : null}

            <br />
            <div className="d-flex justify-content-end">
              <button
                className="btn btn-primary mx-4"
                onClick={() => AddUserCampusesHandle()}
                disabled={loading}
              >
                Submit
              </button>

              <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
              />

              <Link to="/user-campuses">
                <button
                  onClick={() => {
                    setisallfields(false);
                    setUsersArray([]);
                    setCampusIds([]);
                    setClassIds([]);
                    setSelectedCampuses([]);
                    setSelectedClasses([]);
                    setSelectedSections([]);
                    setSelectedSubjects([]);
                    setCreateArray([]);
                    setSelectedUser("");
                    onHide(false);
                  }}
                  type="button"
                  className="btn btn-danger"
                >
                  Cancel
                </button>
              </Link>
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default AddUserCampuses;
